<template>
<div class="chapter">
<div class="inner_page">
<h1 class="toc-title"><a id="page_viii"></a><a id="page_ix"><strong><em>Contents</em></strong></a></h1><a id="page_ix">
</a><p class="toc-fm"><a id="page_ix"></a><a href="#/007_Acknowledgments#fm-1"><em>Acknowledgments</em></a></p>
<p class="toc-fm"><a href="#/008_Preface#fm-2"><em>Preface</em></a></p>
<p class="toc-fm"><a href="#/009_FamilyTree#fm-3"><em>Family Tree</em></a></p>
<p class="toc-part"><a href="#/010_Part01#pt-1"><strong><span class="smallcaps">PART I</span></strong><br/><strong><em>From Vienna to Amsterdam</em></strong></a></p>
<p class="toc-chap"><a href="#/011_Chapter01#ch-1">Refugees</a></p>
<p class="toc-chap"><a href="#/012_Chapter02#ch-2">Amsterdam</a></p>
<p class="toc-chap"><span href="#/013_Chapter03#ch-3" title="Link target outside of Sample">In Hiding</span></p>
<p class="toc-chap"><span href="#/014_Chapter04#ch-4" title="Link target outside of Sample">Capture</span></p>
<p class="toc-chap"><span href="#/015_Chapter05#ch-5" title="Link target outside of Sample">Prison</span></p>
<p class="toc-part"><span href="#/016_Part02#pt-2" title="Link target outside of Sample"><strong><span class="smallcaps">PART II</span></strong><br/><strong><em>Auschwitz-Birkenau</em></strong></span></p>
<p class="toc-chap"><span href="#/017_Chapter06#ch-6" title="Link target outside of Sample">Deported</span></p>
<p class="toc-chap"><span href="#/018_Chapter07#ch-7" title="Link target outside of Sample">Birkenau</span></p>
<p class="toc-chap"><span href="#/019_Chapter08#ch-8" title="Link target outside of Sample">Minni</span></p>
<p class="toc-chap"><span href="#/020_Chapter09#ch-9" title="Link target outside of Sample">“Canada”</span></p>
<p class="toc-chap"><span href="#/021_Chapter10#ch-10" title="Link target outside of Sample">Reunion</span></p>
<p class="toc-chap"><a id="page_x"></a><span href="#/022_Chapter11#ch-11" title="Link target outside of Sample">Alone</span></p>
<p class="toc-chap"><span href="#/023_Chapter12#ch-12" title="Link target outside of Sample">Pappy</span></p>
<p class="toc-chap"><span href="#/024_Chapter13#ch-13" title="Link target outside of Sample">Mutti’s Story</span></p>
<p class="toc-chap"><span href="#/025_Chapter14#ch-14" title="Link target outside of Sample">Mutti</span></p>
<p class="toc-chap"><span href="#/026_Chapter15#ch-15" title="Link target outside of Sample">Liberation</span></p>
<p class="toc-part"><span href="#/027_Part03#pt-3" title="Link target outside of Sample"><strong><span class="smallcaps">PART III</span></strong><br/><strong><em>Journey through Russia</em></strong></span></p>
<p class="toc-chap"><span href="#/028_Map#ch-16" title="Link target outside of Sample">Map of Journey</span></p>
<p class="toc-chap"><span href="#/029_Chapter16#ch-17" title="Link target outside of Sample">The Russians</span></p>
<p class="toc-chap"><span href="#/030_Chapter17#ch-18" title="Link target outside of Sample">Outside the Gate</span></p>
<p class="toc-chap"><span href="#/031_Chapter18#ch-19" title="Link target outside of Sample">The Road to Auschwitz</span></p>
<p class="toc-chap"><span href="#/032_Chapter19#ch-20" title="Link target outside of Sample">Auschwitz</span></p>
<p class="toc-chap"><span href="#/033_Chapter20#ch-21" title="Link target outside of Sample">Katowice</span></p>
<p class="toc-chap"><span href="#/034_Chapter21#ch-22" title="Link target outside of Sample">Czernowitz</span></p>
<p class="toc-chap"><span href="#/035_Chapter22#ch-23" title="Link target outside of Sample">Mutti’s Journey</span></p>
<p class="toc-chap"><span href="#/036_Chapter23#ch-24" title="Link target outside of Sample">Odessa</span></p>
<p class="toc-chap"><span href="#/037_Chapter24#ch-25" title="Link target outside of Sample">Repatriation</span></p>
<p class="toc-chap"><span href="#/038_Chapter25#ch-26" title="Link target outside of Sample">Holland</span></p>
<p class="toc-bm1"><span href="#/039_Epilogue#bm-1" title="Link target outside of Sample">Epilogue</span></p>
<p class="toc-bm"><span href="#/040_Postscript#bm-2" title="Link target outside of Sample">Postscript by Fritzi Frank</span></p>
<p class="toc-bm"><span href="#/041_MyStory#bm-3" title="Link target outside of Sample">“My Story Is the Story of Anne Frank after Her <em>Diary</em> Ends,” <em>An Interview with Eva Schloss</em></span></p>
<p class="toc-bm"><span href="#/042_Discussion#bm-4" title="Link target outside of Sample">Discussion Questions</span></p>
<p class="toc-bm"><span href="#/043_Recommended#bm-5" title="Link target outside of Sample">Recommended Resources</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 006_Contents.vue?c1fc0480